
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import Checkbox from 'element-ui/lib/checkbox';

var script = {
  name: 'PendoCheckbox',
  components: {
    ElCheckbox: Checkbox
  },
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [String, Boolean, Number],
      default: false
    },
    label: {
      type: String,
      default: null
    },
    trueValue: {
      type: [String, Number],
      default: null
    },
    falseValue: {
      type: [String, Number],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: null
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    checkboxGroupChild: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    model: {
      get() {
        return this.value;
      },

      set(val) {
        if (this.checkboxGroupChild) {
          return;
        }

        this.$emit('change', val);
      }

    }
  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-checkbox"
  }, [!_vm.checkboxGroupChild ? _c('el-checkbox', {
    attrs: {
      "name": _vm.name,
      "true-label": _vm.trueValue,
      "false-label": _vm.falseValue,
      "border": false,
      "indeterminate": _vm.indeterminate,
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.model,
      callback: function ($$v) {
        _vm.model = $$v;
      },
      expression: "model"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.checkboxGroupChild ? _c('el-checkbox', {
    attrs: {
      "label": _vm.model,
      "name": _vm.name,
      "true-label": _vm.trueValue,
      "false-label": _vm.falseValue,
      "border": false,
      "indeterminate": _vm.indeterminate,
      "disabled": _vm.disabled
    }
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]) : _vm._e()], 1);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-checkbox.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoCheckbox = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoCheckbox;
